import {
  Box,
  CircularProgress,
  Dialog,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material"
import { useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"
import CloseIcon from "@mui/icons-material/Close"
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  StyledButton,
} from "../HelpCenter/Atom"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { useSelector } from "react-redux"

const NewRoleModal = (props: any) => {
  const {
    open,
    loading,
    setOpen,
    handleCreateNewRole,
    handleEditRole,
    isDisabled,
    setIsDisabled,
  } = props
  const { editState, setEditState } = props

  const roleCategories = useSelector((state: any) => {
    return state.rolesAndPerms.roleCategories
  })

  const formatRoleCategory = (roleCategory: string) => {
    return roleCategory
      .split("_")
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  }
  const reverseFormatRoleCategory = (roleCategory: string) => {
    return roleCategory
      .split(" ")
      .map((word: string) => word.charAt(0).toLowerCase() + word.slice(1))
      .join("_")
  }

  const initialState = {
    id: "",
    title: "",
    description: "",
    category: "",
    prefilled: false,
  }

  const [state, setState] = useState({ ...initialState })

  const onChangeHandler = (e: any, field: string) => {
    setState((prev) => {
      let newState: any = { ...prev }
      let newValue = e.target.value

      newState[field] = newValue
      return newState
    })
  }

  const resetAndCloseHandler = () => {
    setState({ ...initialState })
    setEditState({})
    setOpen(false)
  }

  const addRoleHandler = () => {
    setIsDisabled(true)
    if (state?.prefilled) {
      handleEditRole(
        state.id,
        state.title,
        state.description,
        resetAndCloseHandler,
      )
    } else {
      handleCreateNewRole(
        state.id,
        state.title,
        state.description,
        reverseFormatRoleCategory(state.category),
        resetAndCloseHandler,
      )
    }
  }

  const disableSubmit = useMemo(() => {
    return state.title === "" || state.description === ""
  }, [state])

  useEffect(() => {
    if (editState?.id) {
      setState({
        id: editState?.id || "",
        title: editState?.title || "",
        description: editState?.description || "",
        category: editState?.category || "",
        prefilled: true,
      })
    }
  }, [editState])

  return (
    <Dialog open={open} onClose={resetAndCloseHandler} maxWidth="sm">
      {loading?.now ? (
        <DialogBody sx={{ py: "160px" }}>
          <CircularProgress />
          {loading?.message && (
            <Typography
              sx={{
                mt: "10px",
                mx: "40px",
                textAlign: "center",
                lineHeight: 2,
              }}
            >
              {loading?.message}
            </Typography>
          )}
        </DialogBody>
      ) : (
        <DialogBody>
          <DialogHeader>
            <Typography sx={{ fontWeight: "bold" }}>
              {state.prefilled ? "Edit role" : "Add a new role"}
            </Typography>
            <IconButton onClick={resetAndCloseHandler}>
              <CloseIcon />
            </IconButton>
          </DialogHeader>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {/* <TextField
                variant="filled"
                value={state.id}
                label="Role id"
                onChange={(e: any) => onChangeHandler(e, "id")}
              /> */}
              <TextField
                variant="outlined"
                value={state.title}
                label="Role Name"
                onChange={(e: any) => onChangeHandler(e, "title")}
              />
              <TextField
                variant="outlined"
                value={state.description}
                label="Role description"
                multiline
                minRows={3}
                maxRows={3}
                onChange={(e) => onChangeHandler(e, "description")}
              />
              <Typography sx={{ marginBottom: "-10px" }}>
                Role Category
              </Typography>
              <Select
                disabled={state.prefilled}
                key="role-category"
                inputProps={{ "aria-label": "Select Category" }}
                onChange={(e: any) => {
                  onChangeHandler(e, "category")
                }}
                displayEmpty
                renderValue={(selected: any) =>
                  state?.prefilled
                    ? formatRoleCategory(state?.category)
                    : selected
                    ? selected
                    : "Select Category"
                }
                fullWidth
                IconComponent={ExpandMoreIcon}
                value={formatRoleCategory(state?.category)}
                MenuProps={{
                  sx: {
                    px: 1,
                    width: "250px",
                    height: "350px",
                  },
                }}
                variant="outlined"
              >
                {roleCategories?.map((option: any, itemIndex: any) => {
                  return (
                    <MenuItem
                      key={`select-category-${itemIndex}`}
                      value={formatRoleCategory(option?.role_category)}
                      sx={{
                        fontWeight: "bold",
                        m: 1,
                        borderRadius: "5px",
                        whiteSpace: "normal",
                      }}
                    >
                      {formatRoleCategory(option?.role_category)}
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>
          </DialogContent>
          <DialogFooter>
            <StyledButton variant="outlined" onClick={resetAndCloseHandler}>
              Cancel
            </StyledButton>
            <StyledButton
              disabled={disableSubmit || isDisabled}
              variant="contained"
              onClick={addRoleHandler}
              startIcon={isDisabled && <CircularProgress size={"1rem "} />}
            >
              {state?.prefilled ? "Update" : "Create"}
            </StyledButton>
          </DialogFooter>
        </DialogBody>
      )}
    </Dialog>
  )
}

export default NewRoleModal
